import React from 'react'

const AVATAR_COLORS = [
  '#0b6e99', '#9f6b1f', '#ad1a72', '#0f7b6c',
  '#6940a5', '#c4554d', '#337ea9', '#7a8a3a'
]

function initials(email) {
  const name = (email || '?').split('@')[0] || email || '?'
  const parts = name.split(/[._-]+/).filter(Boolean)
  if (parts.length >= 2) {
    return ((parts[0][0] ?? '') + (parts[1][0] ?? '')).toUpperCase()
  }
  return name.slice(0, 2).toUpperCase()
}

function avatarColor(email) {
  let hash = 0
  for (let i = 0; i < (email || '').length; i += 1) {
    hash = (hash * 31 + email.charCodeAt(i)) >>> 0
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length]
}

/**
 * Avatar — circular initials chip. Color and initials are derived
 * deterministically from the email, so the same person is always the
 * same color across the app.
 */
export function Avatar({ email, size = 28, className = '' }) {
  const cls = ['avatar', className].filter(Boolean).join(' ')
  return (
    <span
      className={cls}
      style={{ width: size, height: size, background: avatarColor(email), fontSize: Math.round(size * 0.43) }}
    >
      {initials(email)}
    </span>
  )
}
